// -------------------------------------------------------------
// This file includes all the neccessary dom bindings and initialization to
// run the FBi audio player on the FBi website.
// -------------------------------------------------------------

import React from 'react'
import ReactDOM from 'react-dom'
import AmrapPopoutPlayer from './amrap-popout-player.jsx'
import AmrapMobilePlayer from './amrap-mobile-player.jsx'
import MiniPlayerWithScrub from './mini-player-with-scrub.jsx'
import MiniPlayer from './mini-player.jsx'
import MiniPlayerStandalone from './mini-player-standalone.jsx'
import fastClick from 'fastclick'
import moment from 'moment'
import bridgePlayer from './player-wrapper.js'
import miniPlayerCSS from '../less/mini-player.less'
import objectValues from 'lodash.values'

if (process.env.NODE_ENV === 'development') {
  setTimeout(function () {
    require('preact/devtools');
  }, 2000)
}

window.rebindAudioPlayers = function () {
  if (window.showReactAudioPlayer) {
    const playlists = document.querySelectorAll('.trackList table')
    // Construct playlists when they have the same 'audio-id'
    const playlistObjects = []
    let autoPlay
    for (let i = 0; i < playlists.length; i++) {
      if (!playlists[i].getAttribute('data-audio-url')) {
        break;
      }
      if (!playlistObjects[i]) {
        playlistObjects[i] = {
          title: playlists[i].getAttribute('data-playlist'),
          clockTime: playlists[i].getAttribute('data-starttime'),
          endTime: playlists[i].getAttribute('data-endtime'),
          tracks: []
        }
      }

      const children = playlists[i].querySelectorAll('.playlist-track')
      for (let j = 0; j < children.length; j++) {
        if (children[j].getAttribute('data-timecode')) {
          const playlistObject = {
            id: children[j].id,
            title: children[j].getAttribute('data-title'),
            artist: children[j].getAttribute('data-artist'),
            timeCode: parseInt(moment.duration(moment(children[j].getAttribute('data-timecode')).diff(moment(playlistObjects[i].clockTime))).asSeconds(), 10),
            url: playlists[i].getAttribute('data-audio-url'),
            type: 'ondemand'
          }

          if (children[j].getAttribute('data-time')) {
            playlistObject.timeCode = parseInt(children[j].getAttribute('data-time'), 10)
          }

          playlistObjects[i].tracks.push(playlistObject)

          let miniPlayer

          if (children[j].getAttribute('data-show-scrub-buttons') === 'true') {
            miniPlayer = (
              <MiniPlayerWithScrub
                id={playlistObject.id}
                url={playlistObject.url}
                title={playlistObject.title}
                artist={playlistObject.artist}
                type={'ondemand'}
                timeCode={playlistObject.timeCode}
                loading={false}
                playlist={playlistObjects[i]}
              />
            )
          } else {
            miniPlayer = (
              <MiniPlayer
                id={playlistObject.id}
                url={playlistObject.url}
                title={playlistObject.title}
                artist={playlistObject.artist}
                type={'ondemand'}
                timeCode={playlistObject.timeCode}
                loading={false}
                playlist={playlistObjects[i]}
              />
            )
          }
          if (children[j].querySelector('.play-button')) {
            ReactDOM.render(miniPlayer, children[j].querySelector('.play-button'))
          } else {
            console.log('FBI Audio Player error: No element with class "play-button" was found inside this .fbi-audio-list-item')
          }

          if (children[j].getAttribute('data-autoplay')) {
            autoPlay = playlistObject
          }
        }
      }

      // Add the first timecode at 0:00
      playlistObjects[i].tracks.splice(0, 0, {
        title: playlists[i].getAttribute('data-playlist'),
        timeCode: 0,
        id: playlists[i].getAttribute('data-playlist') + '-0',
        url: playlists[i].getAttribute('data-audio-url'),
        type: 'ondemand'
      })
    }

    if (playlistObjects.length > 0) {
      bridgePlayer.setPlaylist(playlistObjects[0])
      if (!bridgePlayer.getCurrentTrack().title) {
        if (autoPlay) {
          bridgePlayer.setCurrentTrack(
            autoPlay.id,
            autoPlay.url,
            autoPlay.title,
            autoPlay.artist,
            'ondemand',
            autoPlay.timeCode
          )
          bridgePlayer.playTrack()
        } else {
          bridgePlayer.setCurrentTrack(
            playlistObjects[0].tracks[0].id,
            playlistObjects[0].tracks[0].url,
            playlistObjects[0].tracks[0].title,
            playlistObjects[0].tracks[0].artist,
            'ondemand',
            playlistObjects[0].tracks[0].timeCode
          )
        }
      }
    }

    if (window.json.player && objectValues(window.json.player).length > 0) {
      window.liveUrls = objectValues(window.json.player);
    } else {
      window.liveUrls = []
    }

    if (document.getElementById('amrapPlayer')) {
      if (/Mobi/.test(navigator.userAgent)) {
        const topPlayer = ReactDOM.render(<AmrapMobilePlayer liveUrls={window.liveUrls} />, document.getElementById('amrapPlayer'))
      } else {
        const topPlayer = ReactDOM.render(<AmrapPopoutPlayer liveUrls={window.liveUrls} hideShareButtons={true} />, document.getElementById('amrapPlayer'))
      }
    }

    // Grab any individual audio items not in a playlist
    const playerItems = document.getElementsByClassName('amrap-audio-item')
    for (let i = 0; i < playerItems.length; i++) {
      if (playerItems[i].getAttribute('data-audio-url') || playerItems[i].getAttribute('data-loading')) {
        const miniPlayer = (
          <MiniPlayerStandalone
            url={playerItems[i].getAttribute('data-audio-url')}
            title={playerItems[i].getAttribute('data-title')}
            type={playerItems[i].getAttribute('data-type')}
            loading={playerItems[i].getAttribute('data-loading') === 'true'}
            timeCode={playerItems[i].getAttribute('data-timecode') && parseInt(playerItems[i].getAttribute('data-timecode'), 10)}
          />
        )
        if (playerItems[i].querySelector('.play-button')) {
          ReactDOM.render(miniPlayer, playerItems[i].querySelector('.play-button'))
        } else {
          console.log('FBI Audio Player error: No element with class "play-button" was found inside this .fbi-audio-list-item')
        }
      }
    }

  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  // ReactDOM.render(<Demo />, document.getElementById('demo'))
  window.rebindAudioPlayers()
  setTimeout(function () {
    window.rebindAudioPlayers()
  }, 1000)
  // fastClick(document.body);
});

window.reactPlayer = bridgePlayer



// WEBPACK FOOTER //
// ./js/application.js